import { useParams } from "react-router-dom";
import EOI from "./announcements/EOI";
import LogoCompetition from "./announcements/LogoCompetition";
import LandLease from "./announcements/LandLease";
import MPP from "./announcements/MPP";
import AdmissionOpen from "./announcements/AdmissionOpen";

const AnnouncementPage = () => {
  const { title } = useParams();

  const componentMap: Record<string, React.FC> = {
    eoi: EOI,
    logoCompetition: LogoCompetition,
    landLease: LandLease,
    mpp: MPP,
    admissionOpen: AdmissionOpen,
  };

  const Component = componentMap[title || ""];

  if (!Component) return <div>Not Found</div>;

  return (
    <div style={{ padding: "40px" }}>
      <Component />
    </div>
  );
};

export default AnnouncementPage;
